// extracted by mini-css-extract-plugin
export default {"container":"BubblewrapContainer_container__-K10q"};